import '@hotwired/turbo-rails';
import LocalTime from 'local-time';
import './controllers/index';

LocalTime.start();

document.addEventListener('turbo:morph', () => {
  LocalTime.run();
});

// application.js
import Rails from "@rails/ujs";
window.Rails = Rails;
import * as ActiveStorage from "@rails/activestorage";


require("trix");
require("@rails/actiontext");

// This seems to be important since we can't access $ in the remote page responses.
import './v2/add_jquery'

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Usage: https://github.com/Grsmto/simplebar
import SimpleBar from "simplebar";
window.SimpleBar = SimpleBar;

// Usage: https://github.com/themustafaomar/jsvectormap
import "jsvectormap"
import "jsvectormap/dist/maps/world.js"

// AdminKit (required)
import "./v2/theme";
import "./v2/feather";

// Initializers
import "./v2/initializers/action_text";
import "./v2/initializers/flatpickr";
import "./v2/initializers/help_request";
import "./v2/initializers/tom-select";

ActiveStorage.start();
